export default Object.freeze({
  INTERVENTION_PLAN: 1,
  ADMISSION_NOTE: 2,
  HIGH_LOW_INFORM: 3,
  ACHIEVEMENT_INFORM_DECEMBER: 4,
  ACHIEVEMENT_INFORM_MAY: 5,
  ACHIEVEMENT_INFORM_JUNE: 6,
  PURCHASE_REQUEST: 7,
  MEDICAL_PLAN_CONSENT: 8,
});
